export default "__VITE_ASSET__DFr7zWoi__"